export default __webpack_public_path__ + "static/media/taklif3.09831524.svg";